<template>
  <div>
    <layout-header></layout-header>
    <layout-main></layout-main>
    <loading></loading>
  </div>
</template>
<script>
import LayoutHeader from './Header.vue'
import LayoutMain from './Main.vue'
import Loading from "components/common/Loading";
export default {
  components:{
    LayoutHeader,LayoutMain,Loading
  },
  data() {
    return {
      property: 'value',
    };
  },
}
</script>
<style lang="less">

</style>
